import "./publicPath";   // precisa vir antes de tudo: define a base dos chunks
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ConfirmProvider } from "./components/ConfirmProvider";
import { registerServiceWorker } from "./pwa/registerSW";
import { logBoot } from "./pwa/telemetry";
import { initSentry, SentryErrorBoundary } from "./pwa/sentry";
import BiometricGate from "./components/BiometricGate";
import "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

initSentry();
logBoot();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SentryErrorBoundary>
    <BrowserRouter>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <ConfirmProvider>
            {/* Envolve o App, nao uma rota: a tranca vale para a tela que
                estiver aberta quando o app volta do segundo plano. */}
            <BiometricGate>
              <App />
            </BiometricGate>
          </ConfirmProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </SentryErrorBoundary>
);
